import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import IndexNavbar from "../../components/Navbars/IndexNavbar";
import Footer from "../../components/Footers/IndexFooter";

const PrivacyPolicyPage = () => {
  const operator = {
    fullName: "Недугов Герман Владимирович",
    address: "г. Самара, Арцыбушевская улица, 171",
    email: "kaf_sud@samsmu.ru",
    phone: "+7 846 374-10-04 доб. 4450",
    siteUrl: "https://forenscalc.ru",
    policyUrl: "https://forenscalc.ru/privacy/",
    policyDate: "30.08.2026",
  };

  return (
    <>
      <IndexNavbar />
      <main className="section section-lg pt-7">
        <Container className="mt-5 mb-5">
          <Row className="justify-content-center">
            <Col lg="12">
              <Card className="shadow border-0">
                <CardBody className="p-5">
                  <h1 className="mb-4">Политика обработки персональных данных</h1>

                  <h3 className="mt-4">1. Общие положения</h3>
                  <p>
                    1.1. Настоящая Политика разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ
                    «О персональных данных» и определяет позицию Оператора в отношении обработки персональных данных.
                  </p>
                  <p>
                    1.2. Оператором является <strong>{operator.fullName}</strong> (далее – Оператор).
                  </p>
                  <p>1.3. Контактные данные Оператора:</p>
                  <ul>
                    <li><strong>Адрес:</strong> {operator.address}</li>
                    <li><strong>Электронная почта:</strong> {operator.email}</li>
                    <li><strong>Телефон:</strong> {operator.phone}</li>
                  </ul>
                  <p>
                    1.4. Настоящая Политика применяется ко всем посетителям веб-сайта <strong>{operator.siteUrl}</strong>
                    (далее – Сайт).
                  </p>

                  <h3 className="mt-4">2. Статус Сайта и характер обрабатываемых данных</h3>
                  <p>
                    2.1. Сайт предоставляет Пользователям возможность производить различные расчёты с помощью
                    интерактивных калькуляторов.
                  </p>
                  <p>
                    2.2. <strong>Сайт НЕ осуществляет сбор, хранение и обработку персональных данных</strong>,
                    позволяющих установить личность Пользователя, в том числе:
                  </p>
                  <ul>
                    <li>фамилия, имя, отчество;</li>
                    <li>адрес электронной почты;</li>
                    <li>номер телефона;</li>
                    <li>IP-адрес;</li>
                    <li>данные геолокации;</li>
                    <li>файлы cookie (за исключением технических, указанных в разделе 5);</li>
                    <li>иные данные, позволяющие идентифицировать Пользователя.</li>
                  </ul>
                  <p>
                    2.3. Данные, вводимые Пользователем в поля калькуляторов (числовые значения, параметры,
                    показатели), обрабатываются автоматически <strong>исключительно в целях произведения расчёта
                    и предоставления Пользователю его результатов</strong>.
                  </p>
                  <p>
                    2.4. Указанные данные:
                  </p>
                  <ul>
                    <li>обрабатываются в обезличенном виде;</li>
                    <li>не сохраняются на Сайте;</li>
                    <li>не передаются третьим лицам;</li>
                    <li>не позволяют идентифицировать Пользователя.</li>
                  </ul>
                  <p>
                    2.5. В связи с изложенным, данные, вводимые в калькуляторы, <strong>не являются персональными
                    данными</strong> в контексте Федерального закона № 152-ФЗ «О персональных данных».
                  </p>

                  <h3 className="mt-4">3. Цели обработки данных</h3>
                  <p>Оператор обрабатывает данные, вводимые в калькуляторы, исключительно в целях:</p>
                  <ul>
                    <li>предоставления Пользователям возможности получения результатов расчётов;</li>
                    <li>обеспечения работоспособности Сайта и его сервисов.</li>
                  </ul>
                  <p>Иные цели обработки данных отсутствуют.</p>

                  <h3 className="mt-4">4. Правовые основания обработки</h3>
                  <p>
                    4.1. Обработка данных осуществляется в рамках обеспечения функционирования Сайта.
                  </p>
                  <p>
                    4.2. Поскольку данные, вводимые в калькуляторы, не являются персональными данными,
                    <strong>отдельное согласие Пользователя на их обработку не требуется</strong> в соответствии
                    с Федеральным законом № 152-ФЗ.
                  </p>

                  <h3 className="mt-4">5. Использование файлов cookie</h3>
                  <p>
                    5.1. Сайт использует файлы cookie. Cookie — это небольшие текстовые файлы, которые сохраняются
                    на устройстве Пользователя при посещении Сайта и позволяют обеспечить его корректную работу.
                  </p>
                  <p>
                    5.2. <strong>Сайт использует только необходимые (технические) файлы cookie.</strong> Они нужны
                    для базового функционирования Сайта, например, для:
                  </p>
                  <ul>
                    <li>обеспечения безопасности;</li>
                    <li>запоминания настроек сессии;</li>
                    <li>поддержания работоспособности интерактивных элементов (калькуляторов).</li>
                  </ul>
                  <p>
                    5.3. Технические cookie <strong>не собирают и не хранят</strong> персональные данные,
                    <strong>не используются для аналитики, отслеживания пользователей, рекламных или
                    маркетинговых целей</strong>.
                  </p>
                  <p>
                    5.4. Цель использования технических cookie — исключительно обеспечение работоспособности и
                    доступности Сайта для Пользователя.
                  </p>
                  <p>
                    5.5. <strong>Согласие на использование технических cookie не требуется</strong>, так как они
                    являются строго необходимыми для функционирования Сайта. Продолжая использовать Сайт,
                    Пользователь подтверждает, что проинформирован об их использовании.
                  </p>
                  <p>
                    5.6. Пользователь может в любой момент отключить файлы cookie в настройках своего браузера.
                    Однако это может повлиять на корректную работу некоторых функций Сайта.
                  </p>

                  <h3 className="mt-4">6. Хранение и передача данных</h3>
                  <p>
                    6.1. Результаты расчётов и введённые Пользователем данные <strong>не сохраняются</strong> на
                    Сайте и используются <strong>исключительно для однократного предоставления результата</strong>
                    Пользователю.
                  </p>
                  <p>
                    6.2. Оператор <strong>не передаёт</strong> какие-либо данные третьим лицам.
                  </p>
                  <p>
                    6.3. Оператор принимает все необходимые организационные и технические меры для защиты данных
                    от несанкционированного доступа, уничтожения, изменения, блокирования, копирования,
                    распространения и иных неправомерных действий.
                  </p>

                  <h3 className="mt-4">7. Права субъектов персональных данных</h3>
                  <p>
                    7.1. Поскольку Оператор не обрабатывает персональные данные, позволяющие идентифицировать
                    Пользователя, положения Федерального закона № 152-ФЗ о правах субъектов персональных данных
                    (на доступ, уточнение, блокирование, удаление данных) в данном случае <strong>не применяются</strong>.
                  </p>
                  <p>
                    7.2. В случае наличия вопросов или обращений, связанных с работой Сайта или использованием
                    cookie, Пользователь вправе обратиться к Оператору способами, указанными в разделе 9 настоящей
                    Политики.
                  </p>

                  <h3 className="mt-4">8. Изменение Политики</h3>
                  <p>
                    8.1. Оператор вправе вносить изменения в настоящую Политику в связи с изменением законодательства,
                    функционала Сайта и иных обстоятельств.
                  </p>
                  <p>
                    8.2. Актуальная версия Политики всегда доступна по адресу: <strong>{operator.policyUrl}</strong>.
                  </p>
                  <p>
                    8.3. Новая редакция Политики вступает в силу с момента её размещения на Сайте, если иное не
                    предусмотрено новой редакцией Политики.
                  </p>

                  <h3 className="mt-4">9. Контакты для обращений</h3>
                  <p>По всем вопросам, связанным с настоящей Политикой, обработкой данных, использованием файлов cookie, Пользователи могут обращаться:</p>
                  <ul>
                    <li>по электронной почте: <strong>{operator.email}</strong>;</li>
                    <li>по телефону: <strong>{operator.phone}</strong>.</li>
                  </ul>
                  <p>
                    Оператор обязуется рассмотреть обращение и дать ответ в срок, установленный действующим
                    законодательством Российской Федерации.
                  </p>

                  <p className="mt-4"><strong>Дата вступления в силу:</strong> {operator.policyDate}</p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
